import { use } from 'react';

import { ResourceGroupsDataGrid } from '~features/resourceGroups';

import OrganisationActionBar from '../components/organisationActionBar';
import OrganisationContext from '../providers/organisationDetailsContext';

const OrganisationResourceGroupsContainer = () => {
	const organisationContext = use(OrganisationContext);
	const organisationId = organisationContext.organisation?.id ?? '0';

	return (
		<>
			<OrganisationActionBar organisationId={organisationId} showEditButton={false} />
			<ResourceGroupsDataGrid showTitle={true} overwrittenClientId={organisationId} />
		</>
	);
};

export default OrganisationResourceGroupsContainer;
